import { render } from "./mask.vue?vue&type=template&id=f4a4dec6&scoped=true"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"

import "./mask.vue?vue&type=style&index=0&id=f4a4dec6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a4dec6"]])

export default __exports__